<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div 
        v-show="!afterProceedToPay"
        class="row form-group">

        <div class="col">
        </div>

        <AppSearch 
          ref="pageSearch"
          class="col-md-4"
          v-on:search-data-change="loadPaidBill" />
        
      </div>

      <AppFilter 
        v-show="!afterProceedToPay"
        ref="carparkFilter" 
        filterKey="carparkID"
        v-on:filter-data-change="onFilterCarparkChange" />

      <AppFilterDateRange
        v-show="!afterProceedToPay"
        ref="dateRangeFilter" 
        v-on:filter-data-change="onFilterCarparkChange" />
      
      <AppTable 
        v-show="!afterProceedToPay"
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-cell-click="onTableCellClick"
        v-on:table-cell-input="onTableCellInput"
        v-on:table-cell-change="onTableCellChange" />

      <button 
        v-show="afterLoadBill && !afterProceedToPay"
        class="btn btn-rounded btn-info btn-block-xs-only"
        v-on:click="onProceedToPayClick">
        Tag Deposit
      </button>

      <AppTable 
        v-show="afterProceedToPay"
        ref="pageTablePay" 
        v-bind:tableParameter="TAG_PARAM" />

      <AppForm
        v-show="afterProceedToPay"
        ref="pageFormPay" 
        v-bind:formParameter="PAYMENT_PARAM"
        v-on:form-input="onFormInput"/>

      <button 
        v-show="afterProceedToPay"
        class="btn btn-rounded btn-info btn-block-xs-only"
        v-on:click="onActualProceedToPayClick">
        Tag Deposit
      </button>

      <TemplateFeedback ref="pageFeedback" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppFilterDateRange from "@/components/App/AppFilterDateRange";
import AppAddButton from "@/components/App/AppAddButton";
import AppTable from "@/components/App/AppTable";
import AppForm from "@/components/App/AppForm";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

import PageBillCollectionSelect from "@/components/Page/Collection/PageBillCollectionSelect"

var querystring = require('querystring');


const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_billSelected',
    text: ' ',
    table_component: PageBillCollectionSelect,
  },
  {
    key: 'createDate',
    text: 'Bill Date',
    table_custom: helper.tableCustomDatetime,
  },
  {
    key: 'type',
    text: 'Bill Type',
  },
  {
    key: 'billNum',
    text: 'Bill No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;
      return `<a href="${dataItem.invoice}" target="_blank">${dataItem.billNum}</a>`;
    },
  },
  {
    key: 'title',
    text: 'Description',
  },
  {
    key: 'itemAmount',
    text: 'Amount (RM)',
    table_custom: helper.tableCustomMoney,
  },
];

const TAG_PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: '_test0',
    text: 'OR No.',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      if(dataItem['jt-summary']) return;
      return `<a href="${dataItem.invoice}" target="_blank">${dataItem.billNum}</a>`;
    },
  },
  {
    key: 'itemAmount',
    text: 'Amount (RM)',
    table_custom: helper.tableCustomMoney,
  },
  {
    key: 'createDate',
    text: 'OR Date',
    table_custom: helper.tableCustomDatetime,
  },
  {
    key: 'test1',
    text: 'Deposit No.',
  },
  {
    key: 'test2',
    text: 'Deposit Date',
  },
];

const PAYMENT_PARAM = [
  {
    key: 'depositSlipNo',
    text: 'Deposit Slip No',
  },
  {
    key: 'depositSlipDate',
    text: 'Deposit Slip Date',
    form_datepicker: true,
  },
]
const PAYMENT_PARAM_MAP = helper.transformParamToMap(PAYMENT_PARAM);


export default {
  name: "PageTagDepositCash",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppFilterDateRange,
    AppTable,
    AppAddButton,
    AppForm,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Collection' },
        { name: 'Tag Deposit (Cash)' },
      ],

      PARAM,
      TAG_PARAM,

      PAYMENT_PARAM,
      PAYMENT_PARAM_MAP,

      pageStaff: [],
      pagePaymentMethod: [],
      pageCarpark: null,
      pageCustomer: null,
      pageLicense: null,
      pageBill: null,

      afterLoadBill: false,
      afterProceedToPay: false,

      paymentMethodIDGiro: 0,
      paymentMethodIDCheque: 1,
      paymentMethodIDCash: 2,
      paymentMethodIDOnline: 3,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$refs['carparkFilter'].formatFilterOptionText = (dataItem) => dataItem.carparkCode ? `${dataItem.carparkCode} - ${dataItem.name}` : dataItem.name;
    this.loadPaymentMethod();
  },
  methods: {
    loadPaymentMethod() {
      let feedbackItem = 'payment method';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/paymethods/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            // helper.inputSelectSetOption(this.PAYMENT_PARAM_MAP['paymethodID'], this.pagePaymentMethod = response.data);
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.loadCarpark();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadCarpark() {
      let feedbackItem = 'car park data';
      this.$refs['carparkFilter'].setFilterLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageCarpark = response.data;
          this.$refs['carparkFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.carparkID);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['carparkFilter'].setFilterError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadCustomer() {
      let feedbackItem = 'customer data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadLicense();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadLicense() {
      this.afterLoadBill = false;
      
      let feedbackItem = 'license data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['carparkFilter'].filterValue + '/licenses/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageLicense = response.data;
          response.data.forEach(k => {
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
          });
          // this.$refs['licenseFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.licenseID);

          if(response.data && response.data.length > 0) {
            this.loadPaidBill();
          } else {
            this.$refs['pageFeedback'].setFeedbackMessage('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadPaidBill() {
      this.afterLoadBill = false;
      this.$refs['pageTable'].setTableData(this.pageBill = null);

      let feedbackItem = 'bill data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      let url = this.getUrl(this.$refs['carparkFilter'].filterValue);
      url = helper.appendSearchQuery(url, this.$refs['pageSearch'].searchValue);
      
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('');
          this.pageBill = response.data;
          this.pageBill.forEach(k => {
            k['_license'] = this.pageLicense.find(j => helper.compareID(j.id, k['id']));
            if(k['_license']) {
              k['_customer'] = this.pageCustomer.find(j => j.id === k['_license']['customerID']);
              k['_carpark'] = this.pageCarpark.find(j => j.id === k['_license']['carparkID']);
              k['_carparkName'] = (k['_carpark'] || {}).name;
            }
          });
          if(this.pageBill.length > 0) {
            this.afterLoadBill = true;
            this.pageBill.push({'jt-summary' : true, 'test1': 'Total Selected Payable', 'test2': 0});
            this.calculateBillPayable();
          }
          this.$refs['pageTable'].setTableData(this.pageBill);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    calculateBillPayable() {
      // TODO kw1 calculate selected bill amount
      let temp = 0;
      this.pageBill.forEach(k => {
        if(k['_billSelected']) {
          temp += k['itemAmount'];
        }
      });
      this.pageBill[this.pageBill.length - 1]['itemAmount'] = temp;
    },

    getUrl(carparkID) {
      let url = helper.SERVER_URL + '/api2';
      if(carparkID) {
        url += '/carpark/' + carparkID;
      }
      url += '/bills?hasPaid=1';
      // TODO kw1 filter by date and payment type

      return url;
    },

    onFilterCarparkChange(dataIndex) {
      this.$refs['pageTable'].setTableData(this.pageBill = null);
      this.loadLicense();
    },
    onFilterLicenseChange(dataIndex) {
      this.loadPaidBill();
    },

    onAddButtonClick() {
    },
    onTableDataClick(tableData, tableDataIndex) {
    },
    onProceedToPayClick() {
      let temp = [];
      let total = 0;
      this.pageBill.forEach(k => {
        if(k['jt-summary']) {
          return;
        }

        if(k['_billSelected']) {
          temp.push(k);
          // TODO kw1 calculate total amount payable
          total += 1;//k
        }
      });

      if(temp.length === 0) {
        this.$refs['pageFeedback'].setFeedbackError('Please select at least one valid bill before proceed');
        return;
      }

      this.afterProceedToPay = true;
      this.$refs['pageFeedback'].setFeedbackError();
      temp.push({'jt-summary' : true, 'test1': 'Total Amount', 'test2': total});
      this.$refs['pageTablePay'].setTableData(temp);
      this.$refs['pageFormPay'].setForm(true);
    },
    onActualProceedToPayClick() {
      if(!this.$refs['pageFormPay'].validateForm()) {
        // TODO kw1 validate field based on payment method
        let formData = this.$refs['pageFormPay'].formData;
        let paymentMethod = formData['paymethodID'];
        if(paymentMethod === this.paymentMethodIDGiro) {
          // giro
          if(!formData['giroTransactionCode']) {
            this.$refs['pageFormPay'].$refs['jt-form-element-giroTransactionCode'][0].setInputError(`Invalid GIRO transaction code`);
            return;
          }

          // formData['giroTransactionDate'];
        } else if(paymentMethod === this.paymentMethodIDCheque) {
          // cheque
          // formData['chequeBankCode']
          // formData['chequeNumber']
          // formData['chequeDate']
        } else {
          // cash
        }

        this.submitBill();
      }
    },

    async submitBill() {
      // TODO kw1 call post collection and selection?
      let formData = this.$refs['pageFormPay'].formData;

      let bill = null;
      let result = await this.submitSelection(formData, result, bill);
      if(result) {
        for(let bill of this.pageBill) {
          if(bill['jt-summary']) {
            continue;
          }

          let res = await this.submitCollection(formData, result, bill);
          if(!res) {
            return;
          }
        }
      }
    },
    async submitCollection(formData, result, bill) {
      let temp = {};
      temp['staffID'] = formData['staffID'];
      temp['selectionID'] = '';

      return await this.$http
        .post(
          helper.SERVER_URL + '/api2/collections/',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'collections data'));
        })
    },
    async submitSelection(formData, result, bill) {
      let temp = {};
      temp['paymethodID'] = formData['paymethodID'];
      temp['billNum'] = bill['billNum'];
      temp['licenseID'] = bill['licenseID'];

      return await this.$http
        .post(
          helper.SERVER_URL + '/api2/selections/',
          querystring.stringify(temp),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          return response.data;
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', 'selections data'));
        })
    },

    onTableCellClick(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
    },
    onTableCellInput(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
      let tableItem = tableParameter[tableParameterIndex];
      let dataItem = tableData[tableDataIndex];
      if(tableItem.key === '_billSelected') {
        this.$nextTick(() => {
            this.calculateBillPayable();
        });
      }
    },
    onTableCellChange(tableData, tableDataIndex, tableParameter, tableParameterIndex) {
    },

    onFormInput(formData, formParameter, input) {
    },

    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadPaidBill();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Collection/PageTagDepositCash.vue